import GoodListWithData from './data'
export default GoodListWithData
